<script>
    import GPonlyinpremiumtextures from "./gp-onlyinpremiumtextures.svelte";
    import GPonlyinpremiumplants from "./gp-onlyinpremiumplants.svelte";
    import GPonlyinpremiumseasons from "./gp-onlyinpremiumseasons.svelte";
    import GPonlyinpremiumcustombg from "./gp-onlyinpremiumcustombg.svelte";
    import GPonlyinpremiumpackagevegetables from "./gp-onlyinpremiumpackagevegetables.svelte";
    import GPonlyinpremiumpackageextra from "./gp-onlyinpremiumpackageextra.svelte";
    import GPonlyinpremiumgeneral from "./gp-onlyinpremiumgeneral.svelte";
    import jQuery from "jquery";

    let variants = {
        'textures' : GPonlyinpremiumtextures,
        'plants' : GPonlyinpremiumplants,
        'seasons' : GPonlyinpremiumseasons,
        'custombg' : GPonlyinpremiumcustombg,
        'package_vegetables' : GPonlyinpremiumpackagevegetables,
        'package_extra' : GPonlyinpremiumpackageextra,
        'general' : GPonlyinpremiumgeneral
    }
    export let variant;
    export let activationFromWebsiteAvailable;

    export function open (){
        jQuery('#GPOnlyInPremium').modal({});
        jQuery('#GPOnlyInPremium').on('hidden.bs.modal', () => this.$destroy())


        jQuery('#GPOnlyInPremium').on('shown.bs.modal',function (){jQuery(this).find('.btn').focus();});

        //trap focus
        jQuery('#GPOnlyInPremium .close').on('keydown', function(e) {if (e.shiftKey && e.which===9) e.preventDefault();});
        jQuery('#GPOnlyInPremium .btn').on('keydown', function(e) {if (!e.shiftKey && e.which===9) e.preventDefault();});
     };


</script>


<div class="modal fade" tabindex="-1" id="GPOnlyInPremium">
    <div class="modal-dialog">
        <div class="modal-content">
            <slot>
                <svelte:component this="{variants[variant]}" on:upgrade on:activate {activationFromWebsiteAvailable}/>
            </slot>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->

